import { configureStore } from '@reduxjs/toolkit';
import coreReducer from './coreSlice';
import authenticationReducer from '../features/authentication/authenticationSlice';
import homeReducer from '../features/home/homeSlice';
import structureReducer from '../features/structure/structureSlice';
import alertsReducer from '../features/alerts/alertsSlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import schedulesReducer from "../features/schedules/schedulesSlice";
import logsReducer from "../features/logs/logsSlice";

export const store = configureStore({
  reducer: {
    authentication: authenticationReducer,
    home: homeReducer,
    structure: structureReducer,
    alerts: alertsReducer,
    schedules: schedulesReducer,
    core: coreReducer,
    dashboard: dashboardReducer,
    logs: logsReducer,
  },
});
